import React from "react";

const TotalUsersIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        x="0.746338"
        y="0.572876"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#CB3CFF"
      />
      <path
        d="M16.54 18.5941C17.0116 18.5941 17.444 18.3751 17.7937 18.0386C17.4269 17.3808 17.2175 16.6367 17.2175 15.9226C17.2175 15.317 17.3636 14.7458 17.6207 14.2415C17.3018 14.0459 16.929 13.9313 16.5292 13.9313C15.3606 13.9313 14.4133 14.8922 14.4133 16.0775C14.4133 17.263 15.3714 18.5941 16.54 18.5941Z"
        fill="#CB3CFF"
      />
      <path
        d="M17.9631 19.6121C17.7566 19.5675 17.5428 19.5428 17.323 19.5428H15.7495C14.0751 19.5428 12.7175 20.9046 12.7175 22.5846L12.7246 22.9443C12.7246 23.4136 13.104 23.7942 13.5718 23.7942H15.1234C15.1995 21.9251 16.345 20.3317 17.9631 19.6121Z"
        fill="#CB3CFF"
      />
      <path
        d="M20.8701 19.0428C22.3191 19.0428 23.4804 17.3921 23.4804 15.9223C23.4804 14.4526 22.3057 13.261 20.8567 13.261C19.4078 13.261 18.233 14.4526 18.233 15.9223C18.2332 17.3921 19.4211 19.0428 20.8701 19.0428Z"
        fill="#CB3CFF"
      />
      <path
        d="M25.6008 23.9913C25.6008 21.9081 23.9176 20.2195 21.8413 20.2195H19.8901C17.8138 20.2195 16.1306 21.9081 16.1306 23.9913L16.1396 24.4373C16.1396 25.0192 16.6098 25.4911 17.1901 25.4911H24.5595C25.1395 25.4911 25.61 25.0192 25.61 24.4373L25.6008 23.9913Z"
        fill="#CB3CFF"
      />
    </svg>
  );
};

export default TotalUsersIcon;
